export default "/build/images/visa.d39c0cae.png";